<template>
    <div style="height: 100%; overflow-y: auto">
        <b-tabs fill v-model="tabIndex" @input="onInputTabs" nav-wrapper-class="sa-tab-items" content-class="mt-3"
            class="sa-tab" style="height: 100%; padding-bottom: 25px">
            <b-tab title="Consenso">
                <div class="sa-flexbox">
                    <div class="sa-flexbox-body">
                        <div class="sa-flexbox-body-content">
                            <tiny-mce-edit-component ref="cmpTinyMceEditComponent"
                                @updateContent="onUpdateContentTinyMceEditComponent"></tiny-mce-edit-component>
                        </div>
                        <div class="sa-flexbox-body-right" style="width: var(--sidebar-width)">
                            <b-tabs nav-wrapper-class="sa-tab-items" content-class="mt-3" ref="tabs" class="sa-tab" fill
                                style="height: 100%; padding-bottom: 25px">
                                <b-tab title="Informazioni" style="overflow-x: hidden">
                                    <div style="display: flex; flex-direction: column">
                                        <b-row>
                                            <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                                                <label class="sa-label-data">Struttura:</label>
                                                <b-form-select v-model="jsonData.codiceStruttura"
                                                    :options="strutturaOptions" value-field="codiceStruttura"
                                                    text-field="denominazione">
                                                    <template #first>
                                                        <b-form-select-option :value="null"
                                                            disabled>Seleziona</b-form-select-option>
                                                    </template>
                                                </b-form-select>
                                            </b-col>
                                            <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                                                <label class="sa-label-data">Nome:</label>
                                                <b-form-input v-model="jsonData.nomeConsenso"></b-form-input>
                                            </b-col>
                                            <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                                                <label class="sa-label-data">Sezione:</label>
                                                <b-form-select v-model="jsonData.sezione" :options="sezioniOptions"
                                                    value-field="codice" text-field="descrizione">
                                                    <template #first>
                                                        <b-form-select-option :value="null"
                                                            disabled>Seleziona</b-form-select-option>
                                                    </template>
                                                </b-form-select>
                                                <!-- <b-form-input v-model="jsonData.sezione"></b-form-input> -->
                                            </b-col>
                                            <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                                                <label class="sa-label-data">Stato Attuale:</label>
                                                <b-form-select v-model="jsonData.statoAttuale" :options="statiOptions"
                                                    value-field="value" text-field="text">
                                                    <!-- <template #first>
                                                        <b-form-select-option :value="null" disabled>Seleziona</b-form-select-option>
                                                    </template> -->
                                                </b-form-select>
                                                <!-- <b-form-input v-model="jsonData.sezione"></b-form-input> -->
                                            </b-col>
                                            <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                                                <label class="sa-label_data">Data Ora</label>
                                                <date-picker disabled v-model="jsonData.statoAttualeDataOra"
                                                    format="DD-MM-YYYY HH:mm" value-type="timestamp"
                                                    type="datetime"></date-picker>
                                            </b-col>
                                            <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                                                <label class="sa-label-data">Tipologia:</label>
                                                <b-form-select v-model="jsonData.tipologia">
                                                    <template #first>
                                                        <b-form-select-option :value="null"
                                                            disabled>Seleziona</b-form-select-option>
                                                    </template>
                                                    <b-form-select-option
                                                        :value="'FACOLTATIVO'">FACOLTATIVO</b-form-select-option>
                                                    <b-form-select-option
                                                        :value="'OBBLIGATORIO'">OBBLIGATORIO</b-form-select-option>
                                                </b-form-select>
                                            </b-col>
                                            <b-col cols="6">
                                                <label class="sa-label-data">Formato Pagina:</label>
                                                <b-form-select v-model="impaginazione.formato"
                                                    :options="formatiOptions"></b-form-select>
                                            </b-col>
                                            <b-col cols="6">
                                                <label class="sa-label-data">Orientamento:</label>
                                                <b-form-select v-model="impaginazione.orientamento"
                                                    :options="orientamentiOptions"></b-form-select>
                                            </b-col>
                                            <b-col cols="12">
                                                <b-form-checkbox v-model="impaginazione.marginiUguali" switch>Margini
                                                    uguali su tutti i lati</b-form-checkbox>
                                            </b-col>
                                            <b-col cols="6" v-if="impaginazione.marginiUguali">
                                                <label class="sa-label-data">Margini (mm)</label>
                                                <b-form-input v-model.number="impaginazione.margine" type="number"
                                                    min="0"></b-form-input>
                                            </b-col>
                                            <template v-else>
                                                <b-col cols="6" v-for="lato of ['top', 'bottom', 'left', 'right']"
                                                    :key="lato">
                                                    <label class="sa-label-data">{{ lato }} (mm)</label>
                                                    <b-form-input v-model.number="impaginazione[lato]" type="number"
                                                        min="0"></b-form-input>
                                                </b-col>
                                            </template>
                                            <b-col cols="12">
                                                <small class="text-muted">Area utile: {{ areaUtile }}</small>
                                            </b-col>
                                            <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                                                <label class="sa-label-data">Tipo Firma:</label>
                                                <b-row>
                                                    <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                                                        <b-form-checkbox
                                                            :checked="isTipoFirmaSelected('firmaGrafometrica')"
                                                            @change="onChangeTipoFirma('firmaGrafometrica', $event)">Firma
                                                            Grafometrica</b-form-checkbox>
                                                    </b-col>
                                                    <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                                                        <b-form-checkbox :checked="isTipoFirmaSelected('firmaDigitale')"
                                                            @change="onChangeTipoFirma('firmaDigitale', $event)">Firma
                                                            Digitale</b-form-checkbox>
                                                    </b-col>
                                                </b-row>
                                            </b-col>
                                        </b-row>
                                    </div>
                                </b-tab>
                                <b-tab title="Tags">
                                    <b-tabs fill end>
                                        <b-tab :title="`Selezionati (${tagsSelezionati.length})`">
                                            <div
                                                style="display: flex; align-items: center; justify-content: space-between; margin-top: 12px; gap: 6px">
                                                <small class="text-muted">Tag trovati nel testo</small>
                                                <b-button size="sm" variant="outline-primary"
                                                    @click="onClickAggiornaTagSelezionati"
                                                    title="Rilegge il testo del consenso e aggiorna l'elenco dei tag">
                                                    <i class="fas fa-sync-alt"></i> Aggiorna
                                                </b-button>
                                            </div>
                                            <div v-if="tagsNonNelJson.length > 0" class="ft-tag-warning">
                                                {{ tagsNonNelJson.length }} tag non presenti nel JSON di riferimento
                                            </div>
                                            <div style="height: 460px; margin-top: 8px; overflow-y: scroll">
                                                <template v-if="tagsSelezionati.length > 0">
                                                    <div :class="{ 'sa-badge': true, 'ft-tag-mancante': tag.nelJson === false }"
                                                        style="width: 100%" v-for="tag of tagsSelezionati"
                                                        :key="tag.nome"
                                                        :title="tag.nelJson === false ? 'Tag non presente nel JSON di riferimento' : ''">
                                                        <div class="sa-badge-label"
                                                            style="display: flex; justify-content: space-between; gap: 6px">
                                                            <span>{{ tag.tag }}</span>
                                                            <span v-if="tag.occorrenze > 1" class="ft-tag-count">x{{
                                                                tag.occorrenze }}</span>
                                                        </div>
                                                    </div>
                                                </template>
                                                <template v-else>
                                                    <div class="sa-badge-label">Nessun Tag Selezionato</div>
                                                </template>
                                            </div>
                                        </b-tab>
                                        <b-tab title="Caricati">
                                            <div style="height: 500px; margin-top: 12px; overflow-y: scroll">
                                                <template v-if="tagsItems.length > 0">
                                                    <div v-for="(tag, index) of tagsItems" :key="index"
                                                        :class="{ 'sa-badge': true, 'ft-draggable-block': true }"
                                                        @dragstart="onDragStart(tag, $event)" draggable="true"
                                                        style="width: 100%">
                                                        <div class="sa-badge-label">{{ tag.tag }}</div>
                                                    </div>
                                                </template>
                                                <template v-else>
                                                    <div class="sa-badge-label">Nessun Tag Caricato</div>
                                                </template>
                                                <hr />
                                                <span>Default Tags</span>
                                                <hr />
                                                <template>
                                                    <div v-for="(deafultTags, deafultTagsIndex) of defaultTagsItems"
                                                        :key="deafultTags.nome + deafultTagsIndex"
                                                        :class="{ 'sa-badge': true, 'ft-draggable-block': true }"
                                                        @dragstart="onDragStart(deafultTags, $event)" draggable="true"
                                                        style="width: 100%">
                                                        <div class="sa-badge-label">{{ deafultTags.tag }}</div>
                                                    </div>
                                                </template>
                                                <!-- <div :class="{ 'sa-badge': true, 'ft-active-class': isActiveTag(tag), 'ft-active-selected': isSelectedTag(tag) }" @click="onSelezionaTag(tag)" style="width: 100%" v-for="(tag, index) of tagsItems" :key="index">
                    <div class="sa-badge-label">{{ tag.tag }}</div>
                  </div> -->
                                            </div>
                                        </b-tab>
                                    </b-tabs>
                                </b-tab>
                            </b-tabs>
                        </div>
                    </div>
                </div>
            </b-tab>
            <b-tab title="Prewiew">
                <div v-if="pdfViewer != null"
                    style="padding: 5px; display: flex; justify-content: center; width: 100%; height: 100%; padding-bottom: 20px; padding-left: 10px; padding-right: 10px">
                    <b-embed type="iframe" v-show="showPdf" :src="pdfViewer" allowfullscreen></b-embed>
                </div>
                <div v-else
                    style="display: flex; align-items: center; text-align: center; justify-content: center; height: 100%">
                    <div class="sa-badge-large">Pdf non ancora disponibile, riprovare la preview</div>
                </div>
            </b-tab>
            <b-tab title="JSON">
                <b-row>
                    <b-col cols="9">
                        <label class="sa-label-data">Json di Riferimento <font-awesome-icon icon="times-circle"
                                style="color: #c82333 !important" v-if="jsonError" /> <font-awesome-icon
                                style="color: #218838 !important" icon="check-circle" v-else /></label>
                        <b-form-textarea v-model="jsonData.dataModel" no-resize rows="30"></b-form-textarea>
                    </b-col>
                    <b-col cols="3">
                        <div style="height: 500px; margin-top: 12px; overflow-y: scroll">
                            <template v-if="tagsItems.length > 0">
                                <label class="sa-label-data">Tags Caricati</label>
                                <div :class="{ 'sa-badge': true, 'ft-draggable-block': true }"
                                    @dragstart="onDragStart(tag, $event)" draggable="true" style="width: 100%"
                                    v-for="(tag, index) of tagsItems" :key="index">
                                    <div class="sa-badge-label">{{ tag.tag }}</div>
                                </div>
                            </template>
                            <template v-else>
                                <div class="sa-badge-label">Nessun Tag Caricato</div>
                            </template>
                        </div>
                    </b-col>
                </b-row>
            </b-tab>
        </b-tabs>
    </div>
</template>

<script>
import axios from "axios";
import DatePicker from "vue2-datepicker";
import StruttureMixin from "../../strutture/mixins/StruttureMixin";
import UtilityMixin from "../../utility/UtilityMixin";
import TinyMceEditComponent from "../../utility/components/TinyMceEditComponent.vue";
export default {
    inject: ["openShowModalLoading", "closeShowModalLoading"],
    components: { TinyMceEditComponent, DatePicker },
    mixins: [UtilityMixin, StruttureMixin],
    data() {
        return {
            id: "-1",
            // Salvata nel campo "margini" come "FORMATO;orientamento;top,bottom,left,right" (mm)
            impaginazione: {
                formato: "A4",
                orientamento: "portrait",
                marginiUguali: true,
                margine: 15,
                top: 15,
                bottom: 15,
                left: 15,
                right: 15,
            },
            formatiOptions: [
                { value: "A4", text: "A4 (210 x 297 mm)" },
                { value: "A3", text: "A3 (297 x 420 mm)" },
                { value: "A5", text: "A5 (148 x 210 mm)" },
                { value: "LETTER", text: "Letter (216 x 279 mm)" },
                { value: "LEGAL", text: "Legal (216 x 356 mm)" },
            ],
            orientamentiOptions: [
                { value: "portrait", text: "Verticale" },
                { value: "landscape", text: "Orizzontale" },
            ],
            showPdf: false,
            pdfViewer: null,
            caricaTagsBtn: false,
            statiOptions: [
                { value: null, text: "-Seleziona Valore-" },
                { value: "ATTIVO", text: "ATTIVO" },
                { value: "DEPRECATO", text: "DEPRECATO" },
            ],
            closePage: true,
            jsonData: {
                nomeConsenso: "",
                statoAttuale: "ATTIVO",
                statoAttualeDataOra: new Date().getTime(),
                tipologia: null,
                reportName: "",
                sezione: null,
                descrizione: "",
                codiceStruttura: null,
                testoConsenso: null,
                dataModel: "",
                margini: "",
                tipoFirma: null,
            },
            tabIndex: 0,
            jsonError: false,
            tagsNonPresenti: [],
            tagsItems: [],
            tagsSelezionati: [],
            tagSelezionato: null,
            pathResourceTag: "/consensitag",
            pathResource: "/consensi",
            content: "",
            linkStrutture: "/strutture",
            pathResourceSezioni: "/consensisezioni",
            strutturaOptions: [],
            sezioniOptions: [],
            tag: {
                nome: "",
                note: null,
                tag: "",
            },
            defaultTagsItems: [
                { nome: "sigAssistito", tag: "${sigAssistito}" },
                { nome: "sigPaziente", tag: "${sigPaziente}" },
                { nome: "sigOspite", tag: "${sigOspite}" },
                { nome: "sig", tag: "${sig}" },
                { nome: "data", tag: "${data}" },
                { nome: "dataOra", tag: "${dataOra}" },
            ],
            draggedElementTag: null,
        };
    },
    watch: {
        content(newVal) {
            this.jsonData.testoConsenso = newVal;
            if (this.id != "-1") {
                this.setTagSelezionati();
            }
        },
        "jsonData.dataModel": function (params) {
            let me = this;
            try {
                JSON.parse(params);
                me.jsonError = false;
                me.caricaTagsBtn = true;
            } catch (e) {
                me.jsonError = true;
                me.caricaTagsBtn = false;
            }
        },
    },
    computed: {
        tagsNonNelJson() {
            return this.tagsSelezionati.filter((t) => t.nelJson === false);
        },
        areaUtile() {
            const dimensioni = { A3: [297, 420], A4: [210, 297], A5: [148, 210], LETTER: [216, 279], LEGAL: [216, 356] };
            let [w, h] = dimensioni[this.impaginazione.formato] || dimensioni.A4;
            if (this.impaginazione.orientamento === "landscape") [w, h] = [h, w];
            const m = this.getMarginiArray();
            return `${Math.max(w - m[2] - m[3], 0)} x ${Math.max(h - m[0] - m[1], 0)} mm`;
        },
    },
    mounted() {
        this.loadStrutture();
        this.loadSezioni();
        this.id = this.$route.params.id;
        this.tagsItems = [];
        if (this.id != "-1") {
            this.loadConsenso();
        }
    },
    methods: {
        getConsenso() {
            return this.jsonData;
        },
        loadConsenso() {
            this.openShowModalLoading();
            UtilityMixin.methods.loadDataResources("/consensi/" + this.id, {}, this.loadConsensoSuccess, this.loadConsensoError);
        },

        loadConsensoSuccess(response) {
            this.jsonData = response.data.data;
            this.$refs.cmpTinyMceEditComponent.setContent(this.jsonData.testoConsenso);
            this.setTagSelezionati();
            this.setMargini();
            this.setTags();
            this.closeShowModalLoading();
        },
        loadConsensoError(error) {
            console.log(error);
            this.closeShowModalLoading();
        },
        onEditInit(event) {
            console.log(event);
        },
        onInputTabs(tab) {
            this.$emit("inputTab", tab);
        },
        onDragStart(item, event) {
            console.log(item);

            this.draggedElementTag = item;
            event.dataTransfer.setData("text/html", `<span class="inserted-tag">${item.tag}</span>`);
        },
        getLabelMargine(labelMargine) {
            let returnValue = labelMargine.replace("margine", "");
            if (returnValue == "") {
                returnValue = "All";
            }
            return returnValue;
        },
        onClickSetTags() {
            this.tagsItems = [];
            if (!this.jsonError) {
                this.setTags(null, null);
            }
        },
        onClickPreview() {
            const item = {
                idConsenso: this.jsonData.id,
                data: this.jsonData.dataModel,
                testoConsenso: this.jsonData.testoConsenso,
                margini: this.buildImpaginazione(),
            };

            this.openShowModalLoading();

            axios
                .post(`${process.env.VUE_APP_PATH_API}${this.pathResource}/create`, item)
                .then((response) => {
                    console.log(response);

                    this.$bvToast.toast("Preview Caricata con successo", {
                        title: "Operazione Avvenuta con Successo",
                        variant: "success",
                        solid: true,
                    });

                    // Conversione sicura da Base64 a Blob URL per il viewer
                    const base64Data = response.data.data;
                    const blob = this.base64ToBlob(base64Data, 'application/pdf');

                    // Revoca il vecchio ObjectURL se esiste già per evitare memory leak
                    if (this.pdfViewer && this.pdfViewer.startsWith('blob:')) {
                        URL.revokeObjectURL(this.pdfViewer);
                    }

                    this.pdfViewer = URL.createObjectURL(blob);
                    this.showPdf = true;
                })
                .catch((err) => {
                    // Gestione opzionale del messaggio di errore
                    const messaggioErrore = err.response?.data?.messaggio || "Si è verificato un errore imprevisto.";

                    this.$bvToast.toast(messaggioErrore, {
                        title: "Attenzione",
                        variant: "danger",
                        solid: true,
                    });
                    console.error(err);
                })
                .finally(() => {
                    // Garantisce sempre la chiusura della modale
                    this.closeShowModalLoading();
                });
        },

        // Helper method da aggiungere ai tuoi methods
        base64ToBlob(base64, mimeType = 'application/pdf') {
            const byteCharacters = atob(base64);
            const byteNumbers = new Array(byteCharacters.length);
            for (let i = 0; i < byteCharacters.length; i++) {
                byteNumbers[i] = byteCharacters.charCodeAt(i);
            }
            const byteArray = new Uint8Array(byteNumbers);
            return new Blob([byteArray], { type: mimeType });
        },
        isTipoFirmaSelected(tipoFirma) {
            return this.normalizeTipoFirma(this.jsonData.tipoFirma) === tipoFirma;
        },
        onChangeTipoFirma(tipoFirma, checked) {
            this.$set(this.jsonData, "tipoFirma", checked ? tipoFirma : null);
        },
        normalizeTipoFirma(tipoFirma) {
            if (tipoFirma === "DIGITALE") {
                return "firmaDigitale";
            }
            if (tipoFirma === "GRAFOMETRICA") {
                return "firmaGrafometrica";
            }
            return tipoFirma;
        },

        setTags(data, keyf) {
            let json = {};
            if (!data) {
                json = JSON.parse(this.jsonData.dataModel);
            } else {
                json = JSON.parse(data);
            }
            for (let key of Object.keys(json)) {
                let tag = "";
                if (!keyf) {
                    tag = "$".concat("{").concat(key).concat("}");
                } else {
                    tag = "$".concat("{").concat(keyf).concat(".").concat(key).concat("}");
                }

                if (typeof json[key] != "object") {
                    this.tagsItems.push({ tag: tag });
                }
                if (json[key] && typeof json[key] === "object") {
                    this.setTags(JSON.stringify(json[key]), key);
                }
            }
            // if (this.tagsItems.indexOf({ tag: "${`sign`}" }) == -1) {
            // 	console.log("creazione tag ${sign}");

            // 	this.tagsItems.push({ tag: "${`sign`}" });
            // }
        },
        // Accetta sia il nuovo formato "A4;portrait;10,15,10,10" sia i vecchi "15" / "10,15,10,10"
        setMargini() {
            const valore = (this.jsonData.margini || "").toString().trim();
            let margini = valore;
            if (valore.includes(";")) {
                const parti = valore.split(";");
                this.impaginazione.formato = parti[0] || "A4";
                this.impaginazione.orientamento = parti[1] === "landscape" ? "landscape" : "portrait";
                margini = parti[2] || "";
            }
            if (margini.includes(",")) {
                const valori = margini.split(",").map((v) => Number(v) || 0);
                ["top", "bottom", "left", "right"].forEach((lato, index) => (this.impaginazione[lato] = valori[index] ?? 15));
                this.impaginazione.marginiUguali = valori.every((v) => v === valori[0]);
                this.impaginazione.margine = valori[0];
            } else if (margini !== "") {
                this.impaginazione.marginiUguali = true;
                this.impaginazione.margine = Number(margini) || 0;
            }
        },
        getMarginiArray() {
            const imp = this.impaginazione;
            if (imp.marginiUguali) {
                const m = Number(imp.margine) || 0;
                return [m, m, m, m];
            }
            return ["top", "bottom", "left", "right"].map((lato) => Number(imp[lato]) || 0);
        },
        buildImpaginazione() {
            return `${this.impaginazione.formato};${this.impaginazione.orientamento};${this.getMarginiArray().join(",")}`;
        },
        linkClass(idx) {
            if (this.tabIndex === idx) {
                return ["bg-primary", "text-light"];
            } else {
                return ["bg-light", "text-info"];
            }
        },
        // Nome "pulito" di un tag: ${nome!} / ${nome!"x"} / ${nome?string} -> nome
        normalizzaNomeTag(tag) {
            return tag
                .replace(/^\$\{/, "")
                .replace(/\}$/, "")
                .split(/[!?]/)[0]
                .trim();
        },
        // Rilegge il testo del consenso: elenco dei tag usati (senza doppioni), con numero di occorrenze
        // e indicazione se il tag esiste nel JSON di riferimento (tab "Caricati") o tra i Default Tags.
        setTagSelezionati() {
            const testo = this.jsonData.testoConsenso || "";
            const risultati = testo.match(/\$\{[^}]+\}/g) || [];
            const conosciuti = new Set(
                [...this.tagsItems, ...this.defaultTagsItems].map((t) => this.normalizzaNomeTag(t.tag))
            );
            const verificaJson = this.tagsItems.length > 0;
            const mappa = new Map();
            for (const risultato of risultati) {
                const nome = this.normalizzaNomeTag(risultato);
                if (!nome) continue;
                if (mappa.has(nome)) {
                    mappa.get(nome).occorrenze++;
                } else {
                    mappa.set(nome, {
                        nome: nome,
                        tag: "${" + nome + "}",
                        testo: true,
                        occorrenze: 1,
                        nelJson: verificaJson ? conosciuti.has(nome) : null,
                    });
                }
            }
            this.tagsSelezionati = Array.from(mappa.values());
        },
        onClickAggiornaTagSelezionati() {
            if (this.$refs.cmpTinyMceEditComponent && this.$refs.cmpTinyMceEditComponent.content != null) {
                this.jsonData.testoConsenso = this.$refs.cmpTinyMceEditComponent.content;
            }
            if (this.tagsItems.length === 0 && this.jsonData.dataModel && !this.jsonError) {
                this.setTags(null, null);
            }
            this.setTagSelezionati();
            this.$bvToast.toast(`${this.tagsSelezionati.length} tag trovati nel testo`, {
                title: "Tag aggiornati",
                variant: this.tagsNonNelJson.length > 0 ? "warning" : "success",
                solid: true,
                autoHideDelay: 2500,
            });
        },
        isSelectedTag(tag) {
            if (this.tagSelezionato != null) {
                if (this.tagSelezionato == tag) {
                    this.tagSelezionato = null;
                } else {
                    this.tagSelezionato = tag;
                }
                return false;
            }
        },
        onSelezionaTag(tag) {
            if (this.isActiveTag(tag)) {
                return;
            }
            console.log(tag, "tag");
        },
        resetjsonData() {
            this.jsonData = {
                nomeConsenso: "",
                tipologia: null,
                reportName: "",
                sezione: "",
                descrizione: "",
                codiceStruttura: null,
                testoConsenso: "",
                tipoFirma: null,
            };
        },
        isActiveTag(tag) {
            const index = this.tagsSelezionati.findIndex((e) => e.nome === this.normalizzaNomeTag(tag.tag));
            if (index == -1) {
                this.tagsNonPresenti.push(tag);
            }

            return index == -1 ? false : true;
        },
        saveResource(closePage) {
            this.closePage = closePage;
            this.jsonData.margini = this.buildImpaginazione();
            this.jsonData.tipoFirma = this.normalizeTipoFirma(this.jsonData.tipoFirma);
            UtilityMixin.methods.saveResource(this.pathResource, this.jsonData, this.onSaveCloseSuccess, this.onSaveCloseError);
        },

        onSaveCloseSuccess(response) {
            response;
            if (this.closePage) {
                this.$router.back();
            }
        },
        onSaveCloseError(error) {
            error;
        },
        loadStrutture() {
            let me = this;
            UtilityMixin.methods.loadDataResources(me.linkStrutture, null, me.loadStruttureSuccess, me.loadStruttureError);
        },
        loadStruttureSuccess(response) {
            let me = this;
            me.strutturaOptions = [];
            me.strutturaOptions = response.data.data;
        },
        loadStruttureError(error) {
            error;
        },
        loadSezioni() {
            let me = this;
            UtilityMixin.methods.loadDataResources(me.pathResourceSezioni, null, me.loadSezioniSuccess, me.loadSezioniError);
        },
        loadSezioniSuccess(response) {
            let me = this;
            me.sezioniOptions = [];
            me.sezioniOptions = response.data.data.list;
            if (me.sezioniOptions.length === 1) {
                me.jsonData.sezione = me.sezioniOptions[0].codice;
            }
        },
        loadSezioniError(error) {
            error;
        },

        onClickFormattaJson() {
            let formatt = JSON.stringify(JSON.parse(this.jsonData.dataModel), null, 4);
            this.jsonData.dataModel = formatt;
        },
        setDatiStruttura() {
            let tmpPresidio = window.localStorage.getItem("presidio");
            //console.log(tmpPresidio);

            if (tmpPresidio) {
                this.presidio = JSON.parse(tmpPresidio);
                this.strutturaLoadDataByCodiceCallBack(this.presidio.codiceStruttura, this.onCallBackDatiStruttura);
            }
        },
        onCallBackDatiStruttura(struttura) {
            this.jsonData.codiceStruttura = struttura.codiceStruttura;
        },
        onUpdateContentTinyMceEditComponent(content) {
            this.jsonData.testoConsenso = content;
            // aggiornamento automatico dei tag selezionati (con un piccolo ritardo mentre si scrive)
            clearTimeout(this.timerTagSelezionati);
            this.timerTagSelezionati = setTimeout(() => this.setTagSelezionati(), 600);
        },
    },
};
</script>

<style scoped>
.ft-tag-mancante {
    border-left-color: #dc3545 !important;
}

.ft-tag-mancante .sa-badge-label {
    color: #dc3545;
}

.ft-tag-count {
    font-size: 11px;
    color: #64748b;
}

.ft-tag-warning {
    margin-top: 6px;
    font-size: 12px;
    color: #856404;
    background-color: #fff3cd;
    border: 1px solid #ffeeba;
    border-radius: 4px;
    padding: 3px 6px;
}

.sa-flexbox-body {
    height: 50px;
    flex: 1;
    display: flex;
    flex-direction: row;
    overflow: hidden;
}

.sa-badge {
    max-width: none !important;
    cursor: pointer;
}

.sa-badge-large {
    font-size: medium;
    border-radius: 5px;
    border-left: 4px solid #d8e280;
    border-top: 1px solid var(--bg-main-nav-bar);
    border-bottom: 1px solid var(--bg-main-nav-bar);
    border-right: 1px solid var(--bg-main-nav-bar);
    padding: 7px !important;
    margin-bottom: 5px;
    max-width: max-content;
}

.sa-badge:hover {
    transform: translateY(-1px);
    box-shadow: 0 6px 16px rgba(0, 0, 0, 0.12);
    background-color: rgba(255, 255, 255, 0.651);
}

.ft-active-selected {
    transform: translateY(-1px);
    box-shadow: 0 2px 10px rgba(63, 63, 63, 0.2);
    border: 1px solid var(--bg-sidebar-item) !important;
    border-color: var(--bg-sidebar-item) !important;
    background-color: var(--bg-button-press-color);
}

.ft-active-class {
    transform: translateY(-1px);
    box-shadow: 0 2px 10px rgba(63, 63, 63, 0.2);
    border: 1px solid var(--bg-sidebar) !important;
    border-color: var(--bg-sidebar) !important;
    background-color: var(--bg-button-press-color);
}

.ft-active-class:hover {
    box-shadow: 0 2px 10px rgba(63, 63, 63, 0.2);
    border: 1px solid var(--bg-sidebar) !important;
    border-color: var(--bg-sidebar) !important;
    background-color: var(--bg-button-press-color);
}

.ft-draggable-block {
    cursor: grab;
}

.ft-draggable-block:active {
    cursor: grabbing;
}
</style>
